import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { debounce } from "lodash";

import { IKImage } from "imagekitio-react";

import { Dropdown, Row, Col, Button, InputGroup, Form, Nav, NavDropdown } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { fetchingShowcase, updateLikes, updateViews } from "actions/showcase";
import InfiniteScroll from "components/infinitescroll";

import LinesEllipsis from "react-lines-ellipsis";
import cx from "classnames";

import styles from "./contentGrid.module.scss";

const ContentGrid = () => {
  const dispatch = useDispatch();
  const [order,setOrder] = useState("ASC");
  const [searchQuery, setSearchQuery] = useState("");

  const loading = useSelector((state) => _.get(state, "showcase.loading"));
  const cardsData = useSelector((state) => _.get(state, "showcase.items", []));
  const pagination = useSelector((state) => _.get(state, "showcase.pagination", {}));
  const nextPage = _.get(pagination, "currentPage", 0) + 1;
  const totalPage = _.get(pagination, "totalPages");
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  const desktop = useMediaQuery({
    query: "(min-width: 768px)",
  });

  const [filter, setFilter] = useState({
    type: "",
    contentType: "",
    category: "",
    industry: "",
    sort: "Name"
  });

  const typeOptions = [
    { label: "All", value: "" },
    { label: "Landing Page", value: "LANDING_PAGE" },
    { label: "Resource Center", value: "RESOURCE_CENTER" },
    { label: "Interactive Content", value: "INTERACTIVE_CONTENT" },
    { label: "Spatial", value: "SPATIAL" },
  ];

  const contentTypeOptions = [
    { label: "All", value: "" },
    { label: "Customer Page", value: "CUSTOMER_PAGE" },
    { label: "Prospect Page", value: "PROSPECT_PAGE" },
    { label: "Templates", value: "TEMPLATE" }
  ];

  const categoryOptions = [
    { label: "All", value: "" },
    { label: "Product Presentation", value: "Product Presentation" },
    { label: "Guidebook", value: "Guidebook" },
    { label: "Blog", value: "Blog" },
    // { label: "Presentation", value: "Presentation" },
    { label: "Product Brochure", value: "Product Brochure" },
    { label: "Company Presentation", value: "Company Presentation" },
    { label: "Events", value: "Events" },
    { label: "Website", value: "Website" },
    // { label: "Presentation Template", value: "Presentation Template" },
    // { label: "Prod Presentation", value: "Prod Presentation" },
    // { label: "Webinar Page", value: "Webinar Page" },
    // { label: "Podcast Page", value: "Podcast Page" },
    { label: "Case Study Page", value: "Case Study Page" },
    // { label: "Prod Catalogue", value: "Prod Catalogue" },
  ];

  const industryOptions = [
    { label: "All", value: "" },
    // { label: "Construction", value: "Construction" },
    { label: "Education", value: "Education" },
    { label: "Financial services", value: "Financial services" },
    { label: "Healthcare", value: "Healthcare" },
    { label: "Engineering", value: "Engineering" },
    { label: "Public service", value: "Public service" },
    { label: "Marketing", value: "Marketing" },
    { label: "Hospitality", value: "Hospitality" },
    { label: "IT" , value: "IT"},
  ];
  
  const sortOptions = [
    { label: "Name", value: "Name" },
    { label: "Date", value: "publishedDate" },
    { label: "Views", value: "Views" },
  ];


  useEffect(() => {
    fetchData(0);
  }, [filter,order,searchQuery]);

  const fetchData = (page) => {
    const request = {
      type: filter.type,
      contentType: filter.contentType,
      category: filter.category,
      industry: filter.industry,
      sort: filter.sort,
      order: order,
      query: searchQuery,
    };

    dispatch(fetchingShowcase(request, page, desktop ? 9 : 10));
  };

  function handlePagination() {
    fetchData(nextPage);
  }

  const onOptionChange = (type, value) => {
    setFilter((state) => {
      return {
        ...state,
        [type]: value,
      };
    });
  };

  const loadMoreTemplates = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    fetchData(nextPage);
  };

  const handleViews = (id) => {
    dispatch(updateViews(id));
  };

  const handleLikes = (id) => {
    dispatch(updateLikes(id));
  };

  const handleOrderChange = (value) => {
    setOrder(value);
  }

  return (
    <div className={styles.contentWrapper}>
      <ShowCaseCard setSearchQuery={setSearchQuery} setType={onOptionChange} contentTypeOptions={contentTypeOptions} />
      <img
        className={styles.asteroidStone}
        src={"/images/contentgridImages/asteroid.png"}
        alt=""
      />
      <div className={styles.filterActions}>
          {desktop && (
            <div className={styles.filterOptions}>
              <div className={styles.filterName}>
                <p>Content Type</p>
                <FilterDropDown
                  type="type"
                  selected={filter.type}
                  onChange={onOptionChange}
                  options={typeOptions}
                />
              </div>
              <div className={styles.filterName}>
                <p>Category</p>
                <FilterDropDown
                  type="category"
                  selected={filter.category}
                  onChange={onOptionChange}
                  options={categoryOptions}
                />
              </div>
              <div className={styles.filterName}>
                <p>Industry</p>
                <FilterDropDown
                  type="industry"
                  selected={filter.industry}
                  onChange={onOptionChange}
                  options={industryOptions}
                />
              </div>
              <div className={cx(styles.filterName, styles.lastFilter)}>
                <p>Sort by: </p>
                <div className={styles.filterIcon}>
                  <img onClick={(e) => handleOrderChange(order === "ASC" ? "DESC" : "ASC")} className={cx(styles.sortIcon, order === "ASC" ? styles.ascending : styles.descending)} alt="sortIcon" src='/images/sortIcon.svg' />
                  <FilterDropDown
                  type="sort"
                  selected={filter.sort}
                  onChange={onOptionChange}
                  options={sortOptions}
                />
                </div>
              </div>
            </div>
          )}

          {!desktop && (
            <MobileFilterDropDown filter={filter} onChange={onOptionChange} handleOrderChange={handleOrderChange} order={order}/>
          )}
        </div>

        {_.isEmpty(cardsData) && loading && (
          <>
            <div className={styles.loadMoreSection}>
              <video className={styles.loaderMessageVideo} loop autoPlay playsInline muted >
                <source src="/images/Workspaceloader.webm" type="video/webm" />
              </video>
            </div>
          </>
        )}

        {cardsData?.length  == 0 && !loading && (
          <>
            <div className={styles.loadMoreSection}>
              <p className={styles.title}>
                " Filters engaged, but alas, the storyboard cosmos remains
                mysteriously silent—a void waiting to be filled by celestial
                narratives yet to be discovered. "
              </p>
            </div>
          </>
        )}

        {!_.isEmpty(cardsData) && (
          <>
            <section className={styles.grid}>
              <InfiniteScroll loading={loading}  hasMore={hasMoreItems} loadMore={loadMoreTemplates} >
                <div className={styles.gridContainer}>
                  {(cardsData || []).map((item, index) => {
                    const cardDetails = {
                      ...item,
                      type: _.replace(item.type, "_", " "),
                    };
                    return (
                      <AssetCards
                        item={cardDetails}
                        handleLikes={handleLikes}
                        handleViews={handleViews}
                        index={index}
                      />
                    );
                  })}
                </div>
              </InfiniteScroll>
            </section>
          </>
        )}

    </div>
  );
};

const pageCounts = [
  { count: '4,381', description: 'Landing Pages' },
  { count: '3,172', description: 'Interactive Pages'},
  { count: '1,697', description: 'Resource Centers' },
  { count: '394', description: 'Spatial Experience' },
];

const AssetCards = ({ item, handleLikes, handleViews, index }) => {
  const [liked, setLiked] = useState(false);
  const desktop = useMediaQuery({
    query: "(min-width: 768px)",
  });

  const onLike = (id) => {
    setLiked(!liked)
    handleLikes(id);
  };

  return (
    <div key={index} className={styles.storyboardCard}>
      <a href={item.url} target="_blank" onClick={() => handleViews(item.id)}>
        {desktop && (
          <IKImage 
            className={cx(styles.desktop, styles.icon)}  
            path={item.desktopIcon ? item.desktopIcon : "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_640.jpg"}           
            transformation={[{
              "width": "600"
            }]} />
        )}
      </a>

      <div className={styles.details}>
        <div className={styles.top}>
          <span className={styles.title}>{item.name} 
          </span>
          <label className={cx(styles.type)}>
            <i className={cx( styles.typeIcon,
                {
                  ["cleverstory-Interactive"]:
                  ["INTERACTIVE CONTENT", "SPATIAL"].includes(item.type),
                },
                {
                  ["cleverstory-landing-page"]: item.type === "LANDING PAGE",
                },
                {
                  ["cleverstory-resource-center"]:
                    item.type === "RESOURCE CENTER",
                }
              )}
            />
            {_.capitalize(item.type)}
          </label>
        </div>
        <div className={styles.subDetails}>
          <span className={styles.owner}>
            <label>By {item.owner}</label>
          </span>

          {/* <span className={styles.likes}>
            {liked ? (
              <img className={styles.likesImg} src="/images/heartFill.svg" onClick={() => onLike(item.id)} />
            ) : (
              <img className={styles.likesImg} src="/images/heart.svg" onClick={() => onLike(item.id)}
              />
            )}
            &nbsp;{item.likes}
          </span> */}

          <span className={styles.views}>
            <i className={"cleverstory-view"} />
            &nbsp;{item.views}
          </span>
        </div>
      </div>

      
      <div className={styles.mobileViewDetails}>
        {!desktop && (
          <>
            <a
              href={item.url}
              target="_blank"
              onClick={() => handleViews(item.id)}
            >
              <IKImage
                className={cx(styles.mobile, styles.icon)}
                path={item.mobileIcon}
                transformation={[{
                  "width": "600"
                }]}
              />
            </a>

            {/* <div className={styles.imageOverlay}>
              <span className={styles.likes}>
                {liked ? (
                  <img
                    className={styles.likesImg}
                    src="/images/heartFill.svg"
                  />
                ) : (
                  <img
                    className={styles.likesImg}
                    src="/images/heart.svg"
                    onClick={() => onLike(item.id)}
                  />
                )}
                &nbsp;{item.likes}
              </span>
            </div> */}
          </>
        )}
        <div className={styles.top}>
          <span className={styles.title}>
            <LinesEllipsis
              basedOn="words"
              text={item.name}
              maxLine="1"
              ellipsis="..."
            />{" "}
              </span>
                <label className={cx(styles.type)}>By {item.owner}</label>
        </div>
        <div className={styles.subDetails}>
          <span className={styles.owner}>
             <i
                className={cx(
                styles.typeIcon,
                  {
                  ["cleverstory-Interactive"]:
                  ["INTERACTIVE CONTENT", "SPATIAL"].includes(item.type),
                  },
                  {
                  ["cleverstory-landing-page"]: 
                    item.type === "LANDING PAGE",
                  },
                  {
                  ["cleverstory-resource-center"]:
                    item.type === "RESOURCE CENTER",
                  }
                )}
              />
              <LinesEllipsis
                basedOn="words"
                text={_.capitalize(item.type)}
                maxLine="2"
                ellipsis="..."
              />
          </span>

            <div className={styles.views}>
              {" "}
              <i className={"cleverstory-view"} /> {item.views}
            </div>
        </div>
      </div>
    </div>
  );
};

const ShowCaseCard = ({ setSearchQuery, setType, contentTypeOptions }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeButton, setActiveButton] = useState('');
  const [searchQueryLocal, setSearchQueryLocal] = useState("");

  const handleButtonClick = (category) => {
    setActiveButton(category);
  };

  const debouncedSetSearchQuery = useCallback(
    debounce((query) => {
      setSearchQuery(query);
    }, 300),
    []
  );

  const handleSearchChange = (e) => {
    setSearchQueryLocal(e.target.value);
    debouncedSetSearchQuery(e.target.value);
  };
  
  useEffect(()=> {
    setType('contentType',activeButton);
  },[activeButton]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    setWindowWidth(window.innerWidth);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={styles.showCaseCard}>
      <div className={styles.cardContainer}>
        <div className={styles.storyBoardNumber}>
          <div className={styles.detailsContainer}>
            { windowWidth > 990 && 
              <CountsDisplay />
            }
            { windowWidth <= 990 && 
              <div className={styles.countItemMobile}>
                3172 Landing Pages, 4381 Interactive Content, 1697 Resource Center & 394 Spatial Experience
              </div>
            }
          </div>
        </div>
        <div className={styles.titleContainer}>
          <span className={styles.main}>Showcase</span>
          <br />
          <span className={styles.subText}>
            Cause we <span className={styles.symbols}>'</span> re a sky
            <span className={styles.symbols}>,</span> <br /> a sky full of stars
          </span>
        </div>
        <div className={styles.actionContainer}>
          <div className={styles.buttonWrapper}>
          {/* {contentTypeOptions.map((category) => (
              <Button
                key={category.label}
                className={`${styles.categoryButton} ${
                  activeButton === category.value ? styles.active : ''
                }`}
                onMouseDown={() => handleButtonClick(category.value)}
              >
                {category.label}
              </Button>
            ))} */}
          </div>

          <InputGroup className={styles.searchBox}>
            <InputGroup.Text className={styles.iconBox} id="basic-addon1">
              <span className={'cleverstory-search'} />
            </InputGroup.Text>
            <Form.Control
              className={styles.inputField}
              placeholder="Search"
              aria-label="Search"
              aria-describedby="basic-addon1"
              value={searchQueryLocal}
              onChange={handleSearchChange}           
            />
          </InputGroup>
        </div>
        <div className={styles.titleContainer}>
          <span className={styles.main}>Showcase</span>
          <br />
          <span className={styles.subText}>
            Cause we <span className={styles.symbols}>'</span> re a sky
            <span className={styles.symbols}>,</span> <br /> a sky full of stars
          </span>
        </div>

        <div className={styles.blenderConatiner}>
          <div className={styles.overlayImage}>
            <img
              className={styles.astronaut}
              src={"/images/contentgridImages/showAstronaut.png"}
              alt=""
            />
            <img
              className={styles.star}
              src={"/images/contentgridImages/stars.png"}
              alt=""
            />
            <img
              className={styles.star2}
              src={"/images/contentgridImages/stars.png"}
              alt=""
            />
            <img
              className={styles.star3}
              src={"/images/contentgridImages/stars.png"}
              alt=""
            />
            <img
              className={styles.star4}
              src={"/images/contentgridImages/stars.png"}
              alt=""
            />
            <img
              className={styles.star5}
              src={"/images/contentgridImages/stars.png"}
              alt=""
            />
          </div>
        </div>
        <img
          className={styles.birds}
          src={"/images/contentgridImages/birds.png"}
          alt=""
        />
        <img
          className={styles.rightLeaf}
          src={"/images/contentgridImages/cardRightLeaf.png"}
          alt=""
        />
        <img
          className={styles.leftLeaf}
          src={"/images/contentgridImages/cardLeftLeaf.png"}
          alt=""
        />
      </div>
    </div>
  );
};

const CountsDisplay = () => {
  return (
    <div className={styles.countsContainer}>
      {pageCounts.map((item, index) => (
        <React.Fragment key={index}>
          <div className={styles.countsItem}>
            <div className={styles.count}>{item.count}</div>
            <div className={styles.description}>{item.description}</div>
          </div>
          <div className={styles.line}></div>
        </React.Fragment>
      ))}
    </div>
  );
};

const FilterDropDown = ({ type, options, selected, onChange, className }) => {
  

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div ref={ref}
      className={cx(styles.dropDownButton, className)}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }} >
      {children}
      <span className={"cleverstory-drop-down"} />
    </div>
  ));

  const selectedOption = _.find(options, function (data) {
    return data.value === selected;
  });

  return (
    <Dropdown className={styles.showcaseFilter}>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        {selectedOption.label}
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.showcaseFilterMenu}>
        {options.map((data, index) => (
          <Dropdown.Item
            onClick={() => onChange(type, data.value)}
            key={index}
            className={cx(styles.contentCard, {
              [styles.selected]: selected === data.value,
            })} >
            {data.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const MobileFilterDropDown = ({ filter, onChange, className, handleOrderChange, order}) => {

  const typeOptions = [
    { label: "All", value: "" },
    { label: "Landing Page", value: "LANDING_PAGE" },
    { label: "Resource Center", value: "RESOURCE_CENTER" },
    { label: "Interactive Content", value: "INTERACTIVE_CONTENT" },
    { label: "Spatial", value: "SPATIAL" },
  ];

  const categoryOptions = [
    { label: "All", value: "" },
    { label: "Product Presentation", value: "Product Presentation" },
    { label: "Guidebook", value: "Guidebook" },
    { label: "Blog", value: "Blog" },
    // { label: "Presentation", value: "Presentation" },
    { label: "Product Brochure", value: "Product Brochure" },
    { label: "Company Presentation", value: "Company Presentation" },
    { label: "Events", value: "Events" },
    { label: "Website", value: "Website" },
    // { label: "Presentation Template", value: "Presentation Template" },
    // { label: "Prod Presentation", value: "Prod Presentation" },
    // { label: "Webinar Page", value: "Webinar Page" },
    // { label: "Podcast Page", value: "Podcast Page" },
    { label: "Case Study Page", value: "Case Study Page" },
    // { label: "Prod Catalogue", value: "Prod Catalogue" },
  ];

  const industryOptions = [
    { label: "All", value: "" },
    // { label: "Construction", value: "Construction" },
    { label: "Education", value: "Education" },
    { label: "Financial services", value: "Financial services" },
    { label: "Healthcare", value: "Healthcare" },
    { label: "Engineering", value: "Engineering" },
    { label: "Public service", value: "Public service" },
    { label: "Marketing", value: "Marketing" },
    { label: "Hospitality", value: "Hospitality" },
    { label: "IT" , value: "IT"},
  ];
  
  const sortOptions = [
    { label: "Name", value: "Name" },
    { label: "Date", value: "Date" },
    { label: "Views", value: "Views" },
  ];

  const CustomToggle = React.forwardRef(
    ({ children, onClick, selected }, ref) => (
      <div ref={ref} className={cx(styles.dropDownButton, className)}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }} >
        {children}
        <span className={"cleverstory-drop-down"} />
      </div>
    )
  );


  const selectedType = _.find(typeOptions, function (data) {
    return data.value === filter.type;
  });

  const selectedCategory = _.find(categoryOptions, function (data) {
    return data.value === filter.category;
  });

  const selectedIndustry = _.find(industryOptions, function (data) {
    return data.value === filter.industry;
  });

  const selectedSort = _.find(sortOptions, function (data) {
    return data.value === filter.sort;
  });

  return (
    <Nav className={styles.mobileFilter} >
      <NavDropdown className={styles.mobileFilterItem} title="Filter By" id="nav-dropdown"
        menuVariant="custom-chevron-dropdown">
         <span>Content Type</span>
          <NavDropdown title={selectedType.label} id="sub-dropdown" className={styles.mobileFilterMenu} >
            {typeOptions.map((item, index) => {
              return (
               <NavDropdown.Item 
                 className={cx(styles.mobileFilterMenu, {[styles.selected]: filter.type === item.value,})} 
                 key={index} 
                 onClick={() => onChange("type", item.value)} >
                {item.label}
               </NavDropdown.Item>
              );
            })}
          </NavDropdown>

        <span>Category</span>

        <NavDropdown title={selectedCategory.label} id="sub-dropdown" className={styles.mobileFilterMenu} >
          {categoryOptions.map((item, index) => {
            return (
              <NavDropdown.Item 
                className={cx(styles.mobileFilterMenu, {[styles.selected]: filter.category === item.value,})}
                key={index}
                onClick={() => onChange("category", item.value)} >
                {item.label}
              </NavDropdown.Item>
            );
          })}
        </NavDropdown>

        <span>Industry</span>

        <NavDropdown title={selectedIndustry.label} id="sub-dropdown" className={styles.mobileFilterMenu} >
          {industryOptions.map((item, index) => {
            return (
              <NavDropdown.Item 
                className={cx(styles.mobileFilterMenu, {[styles.selected]: filter.industry === item.value,})}
                key={index}
                onClick={() => onChange("industry", item.value)} >
                {item.label}
              </NavDropdown.Item>
            );
          })}
        </NavDropdown>
      </NavDropdown>
      <div className={styles.sortContainer}>
        <p>Sort by:</p>
        <img onClick={(e) => handleOrderChange(order === "ASC" ? "DESC" : "ASC")} className={cx(styles.sortIcon, order === "ASC" ? styles.ascending : styles.descending)} alt="sortIcon" src='/images/sortIcon.svg' />
        <NavDropdown className={styles.mobileFilterItem} title={selectedSort.label} id="nav-dropdown"
          menuVariant="custom-chevron-dropdown">
            {sortOptions.map((item, index) => {
              return (
                <NavDropdown.Item key={index} onClick={() => onChange("sort", item.value)} className={cx(styles.mobileFilterMenu, {[styles.selected]: filter.sort === item.value,})} >
                 {item.label}
                </NavDropdown.Item>
              );
            })}
        </NavDropdown>
      </div>
    </Nav>
  );
};

export default ContentGrid;